import { noDataLightMode } from "../../assets/images";
import NoDataView from "./NoDataView";

interface InboxNoDataProps {
  onRetry?: () => void;
  title?: string;
  description?: string;
}

/**
 * Empty-state for the conversation inbox — mirrors mobile usage of NoData
 * with the "no threads" illustration and messaging.
 */
const InboxNoData = ({
  onRetry,
  title = "No conversations yet",
  description = "Your conversations will appear here once they are started.",
}: InboxNoDataProps) => (
  <NoDataView
    image={noDataLightMode}
    title={title}
    description={description}
    onRetry={onRetry}
    retryLabel="Refresh"
  />
);

export default InboxNoData;
